import { useState } from 'react'
import { Copy, Check } from 'lucide-react'

function CopyData({ data, withText = false, customText, className = '' }: { data: string, withText?: boolean, customText?: string, className?: string }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(data)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }
  return (
    <span className={`w-fit flex items-center gap-1 text-sm text-az-teal cursor-pointer whitespace-nowrap text-nowrap ${className}`} onClick={(e) => {
        e.stopPropagation();
        handleCopy();
    }}>
      {
        copied ? <Check className="w-[15px] h-[15px]" /> : <Copy className="w-[15px] h-[15px]" />
      }
      {withText && customText ? customText : withText ? "copy" : null}
    </span>
  )
}

export default CopyData